import { useEffect, useState } from 'react';
import {
  Link,
  useLocation,
} from 'react-router-dom';

import SelectorIdioma from '../SelectorIdioma/SelectorIdioma';
import { useIdioma } from '../../context/IdiomaContext';

import './Navbar.css';

function Navbar() {
  const [haBajado, setHaBajado] =
    useState(false);

  const location = useLocation();
  const { t } = useIdioma();

  const estaEnInicio =
    location.pathname === '/';

  const navbarBlanca =
    !estaEnInicio || haBajado;

  useEffect(() => {
    const controlarScroll = () => {
      setHaBajado(
        window.scrollY >=
          window.innerHeight * 0.5
      );
    };

    window.scrollTo(0, 0);
    controlarScroll();

    window.addEventListener(
      'scroll',
      controlarScroll
    );

    return () => {
      window.removeEventListener(
        'scroll',
        controlarScroll
      );
    };
  }, [location.pathname]);

  return (
    <header>
      <nav
        className={`navbar ${
          navbarBlanca
            ? 'navbar-blanca'
            : ''
        }`}
      >
        <div className="navbar-logo">
          <Link to="/">
            JMMartin Labs
          </Link>
        </div>

        <div className="navbar-parte-inferior">
          <div className="navbar-links">
            <Link to="/">
              {t('navbar.inicio')}
            </Link>

            <Link to="/sobre-mi">
              {t('navbar.sobreMi')}
            </Link>

            <Link to="/servicios">
              {t('navbar.servicios')}
            </Link>

            <Link to="/testimonios">
              {t('navbar.testimonios')}
            </Link>

            {/* 
            <Link to="/blog">
              {t('navbar.blog')}
            </Link>
            */}

            <Link to="/contacto">
              {t('navbar.contacto')}
            </Link>
          </div>

          <SelectorIdioma />
        </div>
      </nav>
    </header>
  );
}

export default Navbar;